import usePartnerContext from "@lib/hooks/usePartnerContext";
import LeadWallBudgetFirstStep from "@modules/application/components/LeadWall/LeadWallBudgetFirstStep";
import useApplicationContext from "@modules/application/hooks/useApplicationContext";
import usePostBudgetCheckWithLead from "@modules/application/hooks/usePostBudgetCheckWithLead";
import { BudgetCheckFormValues } from "@modules/application/lib/budgetCheck/types";
import { FC } from "react";
import { FormStepComponent } from "../FormSteps/FormSteps";

const BudgetCheckLeadWall: FC<FormStepComponent<BudgetCheckFormValues>> = ({
  value,
  onPrevious,
  onNext,
}) => {
  const { state, dispatch } = useApplicationContext();
  const { partner } = usePartnerContext();
  const { isError, isLoading, handleSubmit } = usePostBudgetCheckWithLead({
    partnerId: partner?.id,
    budgetCheckForm: value as BudgetCheckFormValues,
    onSuccess: (maximumBudget, lead) => {
      dispatch({ type: "SET_LEAD", lead });
      dispatch({ type: "SET_MAXIMUM_BUDGET", maximumBudget });
      onNext();
    },
    leadCreationAction: "MAXIMUM_BUDGET_CONTACT_WALL",
  });

  return (
    <>
      <div className="col-span-5">
        <LeadWallBudgetFirstStep
          onSubmit={handleSubmit}
          isError={isError}
          isLoading={isLoading}
          defaultValues={state.lead}
          onPrevious={() => onPrevious()}
        />
      </div>
    </>
  );
};

export default BudgetCheckLeadWall;
